import { Nilable, Nullable } from "@shared/utils";
import { BehaviorSubject, Observable } from "rxjs";
import { ItemPreguntaDTO, PreguntaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";

export class PreguntaModelDTO {
    public changed$: Observable<boolean>;

    private _changed$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _entidad: PreguntaDTO;

    constructor(entidad: PreguntaDTO) {
        this._entidad = entidad;
        this.changed$ = this._changed$.asObservable();
    }

    public get Id(): number {
        return this._entidad.id;
    }

    public set Id(valor: number) {
        this._entidad.id = valor;
    }

    public get Encuesta(): number {
        return this._entidad.encuesta;
    }

    public set Encuesta(valor: number) {
        this._entidad.encuesta = valor;
        this._changed$.next(true);
    }

    public get ImagenUrl(): Nilable<string> {
        return this._entidad.imagenUrl;
    }

    public set ImagenUrl(valor: Nilable<string>) {
        this._entidad.imagenUrl = valor ?? "";
        this._changed$.next(true);
    }

    public get MaximoItemsSeleccionados(): number {
        return this._entidad.maximoItemsSeleccionados;
    }

    public set MaximoItemsSeleccionados(valor: number) {
        this._entidad.maximoItemsSeleccionados = valor;
        this._changed$.next(true);
    }

    public get MinimoItemsSeleccionados(): number {
        return this._entidad.minimoItemsSeleccionados;
    }

    public set MinimoItemsSeleccionados(valor: number) {
        this._entidad.minimoItemsSeleccionados = valor;
        this._changed$.next(true);
    }

    public get Maximo(): Nilable<number> {
        return this._entidad.maximo;
    }

    public set Maximo(valor: Nilable<number>) {
        this._entidad.maximo = valor;
        this._changed$.next(true);
    }

    public get Paso(): Nilable<number> {
        return this._entidad.paso;
    }

    public set Paso(valor: Nilable<number>) {
        this._entidad.paso = valor;
        this._changed$.next(true);
    }

    public get Texto(): string {
        return this._entidad.texto;
    }

    public set Texto(texto: string) {
        this._entidad.texto = texto;
        this._changed$.next(true);
    }

    public get Tipo(): PreguntasTipoEnum {
        return this._entidad.tipo;
    }

    public set Tipo(valor: PreguntasTipoEnum) {
        this._entidad.tipo = valor;
        this._changed$.next(true);
    }

    public get Subtipo(): number {
        return this._entidad.subtipo;
    }

    public set Subtipo(valor: number) {
        this._entidad.subtipo = valor;
        this._changed$.next(true);
    }

    public get Url(): string {
        return this._entidad.url;
    }

    public set Url(valor: string) {
        this._entidad.url = valor;
        this._changed$.next(true);
    }

    public get TiempoMinimo(): number {
        return this._entidad.tiempoMinimo;
    }

    public set TiempoMinimo(valor: number) {
        this._entidad.tiempoMinimo = valor;
        this._changed$.next(true);
    }

    public get MinimoCategoriasItem(): number {
        return this._entidad.minimoCategoriasItem;
    }

    public set MinimoCategoriasItem(valor: number) {
        this._entidad.minimoCategoriasItem = valor;
        this._changed$.next(true);
    }

    public get MaximoCategoriasItem(): number {
        return this._entidad.maximoCategoriasItem;
    }

    public set MaximoCategoriasItem(valor: number) {
        this._entidad.maximoCategoriasItem = valor;
        this._changed$.next(true);
    }

    public get Condiciones(): string {
        return this._entidad.condiciones;
    }

    public set Condiciones(valor: string) {
        this._entidad.condiciones = valor;
        this._changed$.next(true);
    }

    public get TextoReferencia(): string {
        return this._entidad.textoReferencia;
    }

    public set TextoReferencia(valor: string) {
        this._entidad.textoReferencia = valor;
        this._changed$.next(true);
    }

    public get SiguientePregunta(): Nilable<number> {
        return this._entidad.siguientePregunta;
    }

    public set SiguientePregunta(valor: Nilable<number>) {
        this._entidad.siguientePregunta = valor;
        this._changed$.next(true);
    }

    public get Minimo(): Nilable<number> {
        return this._entidad.minimo;
    }

    public set Minimo(valor: Nilable<number>) {
        this._entidad.minimo = valor;
        this._changed$.next(true);
    }

    public get Aleatorio(): Nilable<boolean> {
        return this._entidad.aleatorio;
    }

    public set Aleatorio(random: Nilable<boolean>) {
        this._entidad.aleatorio = random;
        this._changed$.next(true);
    }

    public get Opcional(): boolean {
        return this._entidad.opcional;
    }

    public set Opcional(valor: boolean) {
        this._entidad.opcional = valor;
        this._changed$.next(true);
    }

    public get MinimoRespuestas(): number {
        return this._entidad.minimoRespuestas;
    }

    public set MinimoRespuestas(valor: number) {
        this._entidad.minimoRespuestas = valor;
        this._changed$.next(true);
    }

    public get IdRelativo(): string {
        return this._entidad.idRelativo;
    }

    public set IdRelativo(valor: string) {
        this._entidad.idRelativo = valor;
        this._changed$.next(true);
    }

    public get IdCliente(): string {
        return this._entidad.idCliente;
    }

    public set IdCliente(valor: string) {
        this._entidad.idCliente = valor;
        this._changed$.next(true);
    }

    public get Payload(): any {
        return this._entidad.payload;
    }

    public set Payload(valor: any) {
        this._entidad.payload = valor;
        this._changed$.next(true);
    }

    public get Items(): ItemPreguntaDTO[] {
        return this._entidad.items;
    }

    public set Items(valor: ItemPreguntaDTO[]) {
        this._entidad.items = valor;
        this._changed$.next(true);
    }

    public get Preguntas(): Nullable<PreguntaDTO[]> {
        return this._entidad.preguntas;
    }

    public set Preguntas(valor: Nullable<PreguntaDTO[]>) {
        this._entidad.preguntas = valor;
        this._changed$.next(true);
    }

    public get Padre(): Nilable<number> {
        return this._entidad.padre;
    }

    public set Padre(valor: Nilable<number>) {
        this._entidad.padre = valor;
        this._changed$.next(true);
    }

    public get IdBloque(): Nilable<number> {
        return this._entidad.idBloque;
    }

    public set IdBloque(valor: Nilable<number>) {
        this._entidad.idBloque = valor;
        this._changed$.next(true);
    }

    public get Entidad(): PreguntaDTO {
        return this._entidad;
    }

    public set Entidad(valor: PreguntaDTO) {
        this._entidad = valor;

        this._changed$.next(true);
    }
}
